var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlassRebrand = function SvgMagnifyingGlassRebrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Magnifying-Glass-rebrand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F1F",
    d: "M34.409 34.303a3.974 3.974 0 0 1-5.619 0l-8.517-8.517 2.764-2.764s.135.09.203.112c6.427 3.416 11.168 11.17 11.168 11.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F1F",
    d: "m25.914 20.19 8.517 8.516a3.974 3.974 0 0 1 0 5.619L23.105 22.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF4EC",
    d: "M22.395 5.438c4.651 4.652 4.651 12.202 0 16.854-4.652 4.652-12.18 4.63-16.832-.022S.91 10.067 5.54 5.438c4.652-4.652 12.203-4.652 16.855 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF4EC",
    d: "M22.392 5.432c4.652 4.652 4.652 12.202 0 16.854L5.56 5.454c4.652-4.651 12.203-4.651 16.855 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M4.192 4.116c-5.37 5.37-5.37 14.09 0 19.46 5.371 5.372 14.09 5.372 19.461 0 5.371-5.37 5.371-14.09 0-19.46-5.37-5.371-14.09-5.371-19.46 0m16.832 16.832c-3.91 3.91-10.292 3.91-14.203 0s-3.91-10.293 0-14.203 10.293-3.91 14.203 0 3.91 10.292 0 14.203"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M23.697 4.13c5.371 5.371 5.371 14.09 0 19.461l-2.629-2.629c3.91-3.91 3.91-10.292 0-14.203s-10.292-3.91-14.203 0L4.236 4.13c5.371-5.37 14.09-5.37 19.461 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Magnifying-Glass-rebrand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgMagnifyingGlassRebrand;